import { templateVariableStringToMap, templateVariableMapToString, upsertTemplateVariableMapAtIndex } from '@/utils/templateEngine';
import { encodeSSFArgument } from '@/utils/templateEngine';
import googleSheets from '@/config/googleSheets';
import { isFormatNonAbbreviatable, setPatternDecimal, isPatternHasDecimal } from '@/utils/spreadsheetFormat';
const DEFAULT_SCALABLE_SSF_FORMAT = googleSheets.formats.number; // Add ssf formatting directive to a template variable

export function upsertSsfArg(templateVariable, format) {
  let varMap = templateVariableStringToMap(templateVariable);
  const ssfArgument = encodeSSFArgument(format);
  varMap = upsertTemplateVariableMapAtIndex(varMap, 'ssf', `${ssfArgument}`);
  return templateVariableMapToString(varMap);
} // Remove ssf formatting directive from a template variable

export function removeSsfArg(templateVariable) {
  const varMap = templateVariableStringToMap(templateVariable);
  varMap.delete('ssf');
  return templateVariableMapToString(varMap);
} // Add trim_dec formatting directive to a template variable

export function addTrimDec(templateVariable) {
  let varMap = templateVariableStringToMap(templateVariable);
  varMap = upsertTemplateVariableMapAtIndex(varMap, 'trim_dec', '', 1);
  return templateVariableMapToString(varMap);
} // Remove trim_dec formatting directive from a template variable

export function removeTrimDec(templateVariable) {
  const varMap = templateVariableStringToMap(templateVariable);
  varMap.delete('trim_dec');
  return templateVariableMapToString(varMap);
} // Add abbreviation formatting directive to a template variable

export function addAbbr(templateVariable, abbrArgs) {
  let varMap = templateVariableStringToMap(templateVariable);
  varMap = upsertTemplateVariableMapAtIndex(varMap, 'abbr', `${abbrArgs}`);
  return templateVariableMapToString(varMap);
} // Remove abbreviation formatting directive from a template variable

export function removeAbbr(templateVariable) {
  const varMap = templateVariableStringToMap(templateVariable);
  varMap.delete('abbr');
  return templateVariableMapToString(varMap);
} // Extract the SSF format from a template variable and update its decimal place
// forcing any non-scalable SSF format to be the default number format

export function createNewSsfFormatDecimal(templateVariable, decimalPlace) {
  const varMap = templateVariableStringToMap(templateVariable);
  let format = varMap.get('ssf');

  if (!format || !isPatternHasDecimal(format)) {
    format = DEFAULT_SCALABLE_SSF_FORMAT;
  }

  return setPatternDecimal(format, decimalPlace);
} // Extract the SSF format from a template variable and use any existing
// or forc any non-scalable SSF format to be the default number format

export function useOrCreateAbbreviatableSsfFormat(templateVariable) {
  const varMap = templateVariableStringToMap(templateVariable);
  let format = varMap.get('ssf');

  if (!format || isFormatNonAbbreviatable(format)) {
    format = DEFAULT_SCALABLE_SSF_FORMAT;
  }

  return format;
}